(() => {
	angular
		.module('main')
		.directive('addAmbassadorCodeModal', addAmbassadorCodeModal);

	addAmbassadorCodeModal.$inject = [];

	function addAmbassadorCodeModal() {
		return {
			restrict: 'E',
			scope: {
				ambassador: '=',
				submitAmbassadorCode: '&',
				btnDisable: '<'
			},
			template: `
                    <div id="addAmbassadorCodeModal" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">
                            <div class="modal-dialog" style="max-width: 620px">
                              <div class="modal-content">
                                   <form class="form-horizontal" ng-submit="submitAmbassadorCode({ambassador:ambassador})">
                                        <div class="modal-header">
                                           <btn-close></btn-close>
                                            <h3 class="modal-title">{{ambassador.isAmbassador ? 'Extend ambassador code' : 'Make ambassador'}}</h3>
                                        </div>
                                        <div class="modal-body">
                                                <div class="row form-group">
                                                    <div class="col-sm-3">
                                                        <label class="control-label">First name</label>
                                                    </div>
                                                    <div class="col-sm-9">
                                                        <input type="text" class="form-control" ng-model="ambassador.firstName" disabled>
                                                    </div>
                                                </div>
                                                <div class="row form-group">
                                                    <div class="col-sm-3">
                                                        <label class="control-label">Email</label>
                                                    </div>
                                                    <div class="col-sm-9">
                                                        <input type="email" class="form-control" ng-model="ambassador.email" disabled>
                                                    </div>
                                                </div>
                                                <div class="row form-group">
                                                    <div class="col-sm-3">
                                                        <label class="control-label">Ambassador code</label>
                                                    </div>
                                                    <div class="col-sm-9">
                                                        <input type="text" class="form-control" ng-model="ambassador.code" ng-disabled="ambassador.isAmbassador" required>
                                                    </div>
                                                </div>
                                              
                                                <div class="row form-group">
                                                        <div class="col-sm-3">
                                                             <label class="control-label">Duration</label>
                                                        </div>
                                                        <div class="col-sm-9 job-date">
                                                             <div class="flex-row flex-wrap-xs">
                                                                <div class="flex-grow-1 box-no-transition datepicker-static bottom-0">
                                                                    <input ng-model="ambassador.startDate" class="form-control"
                                                                           disabled type="date" name="input" data-placeholder="dd/mm/yyyy"
                                                                           min="2001-12-31"
                                                                           max="2999-12-31"
                                                                           data-date='{"startView": 2, "openOnMouseFocus": true}' required/>
                                                                </div>
                                                                <div class="flex-basis-xs ms-15">to</div>
                                                               <div class="flex-grow-1 box-no-transition datepicker-static bottom-0 left-n-136">
                                                                    <input ng-model="ambassador.endDate" class="form-control"
                                                                           type="date" name="input" data-placeholder="dd/mm/yyyy"
                                                                           min="{{( ambassador.startDate ) ? ( ambassador.startDate | date : 'yyyy-MM-dd') : (now | date : 'yyyy-MM-dd') }}"
                                                                           max="2999-12-31"
                                                                           data-date='{"startView": 2, "openOnMouseFocus": true}' required/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                      
                                        </div>
                                        <div class="modal-footer modal-foot">
                                            <button type="submit"
                                                    class="btn btn-success btn-lg"
                                                    ng-disabled="btnDisable"
                                                    spinning-wheel is-spinning-wheel-active="btnDisable"
                                            >Save ambassador code
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>`,
			replace: true,
			transclude: true,
			link(scope) {
				scope.ambassador = {};
				scope.now = new Date();
				scope.now.setHours(0, 0, 0, 0);

				scope.$watch('ambassador.startDate', checkCodeDate);

				function checkCodeDate(startDate) {
					if (
						scope.ambassador &&
						(!scope.ambassador.endDate || startDate > scope.ambassador.endDate)
					) {
						scope.ambassador.endDate = startDate;
					}
				}
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/admin/addAmbassadorCodeModal.js